import { apiRequest } from '../api';

// Package "reqdocs": Admin → Jobs → Required documents (server/src/routes/jobRequiredDocs.ts).
export type ReqDateKind = 'expiry' | 'issued' | 'signed' | 'sent' | 'confirmed' | 'reviewed' | 'submitted';
export interface ReqDoc {
  key: string; docName: string; dateKind: ReqDateKind; required: boolean;
  noEmail?: boolean; folderHint?: string; noCompany?: boolean; needsCompany?: boolean; when?: string;
  /** Filed proofs that use this key (read only). */
  filed?: number;
}
export interface ReqRule {
  id: string; sortOrder: number; label: string; match: string; not: string; expand: string;
  docs: ReqDoc[]; notes: string; active: boolean; updatedAt: number; updatedByName: string;
}
export type ReqRuleDraft = Omit<ReqRule, 'id' | 'sortOrder' | 'updatedAt' | 'updatedByName'> & { id?: string };
export interface ReqPreview { rules: string[]; docs: ReqDoc[] }

const BASE = '/job-required-docs';
export const reqdocsApi = {
  list: (): Promise<{ rules: ReqRule[]; dateKinds: ReqDateKind[]; maxExpansions: number }> => apiRequest('GET', BASE),
  create: (rule: ReqRuleDraft): Promise<{ ok: true; rule: ReqRule }> => apiRequest('POST', BASE, { rule }),
  update: (id: string, rule: ReqRuleDraft, force = false): Promise<{ ok: true; rule: ReqRule }> =>
    apiRequest('PUT', `${BASE}/${encodeURIComponent(id)}`, { rule, force }),
  remove: (id: string, force = false): Promise<{ ok: true }> =>
    apiRequest('DELETE', `${BASE}/${encodeURIComponent(id)}${force ? '?force=1' : ''}`),
  reorder: (ids: string[]): Promise<{ ok: true; rules: ReqRule[] }> => apiRequest('POST', `${BASE}/reorder`, { ids }),
  preview: (name: string, rule?: ReqRuleDraft): Promise<ReqPreview> => apiRequest('POST', `${BASE}/preview`, { name, rule }),
};
